export enum ObjectType {
  product = "product",
  accessory = "accessory",
  multisplit = "multisplit",
}

export enum RequestStatus {
  LOADING = 5,
  ERROR = 6,
  SUCCESS = 7,
}
